import { render, staticRenderFns } from "./PersonDetailPage.vue?vue&type=template&id=17be33bd&scoped=true"
import script from "./PersonDetailPage.vue?vue&type=script&lang=js"
export * from "./PersonDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PersonDetailPage.vue?vue&type=style&index=0&id=17be33bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be33bd",
  null
  
)

export default component.exports